import { render } from "./ImportClientes.vue?vue&type=template&id=254dd8d4"
import script from "./ImportClientes.vue?vue&type=script&lang=js"
export * from "./ImportClientes.vue?vue&type=script&lang=js"

import "./ImportClientes.vue?vue&type=style&index=0&id=254dd8d4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__